import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonSnackbarComponent, CustomSnackBarData } from '@shared/components/common-snackbar/common-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private _snackBar: MatSnackBar) {}

  Success(message: string, duration: number = 2000) {

     const data: CustomSnackBarData = {
      icon: 'check_circle',
      title: 'Success',
      message: message,
      color: ' #5cb85c',
      duration: duration
    };

    this._snackBar.openFromComponent(CommonSnackbarComponent, {
      data,
      duration: duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'custom-snackbar'
    });
  }

  Error(message: string, duration: number = 2000) {
    const data: CustomSnackBarData = {
      icon: 'error',
      title: 'Error Occurred',
      message: message,
      color: '#f44336',
      duration: duration
    };

    this._snackBar.openFromComponent(CommonSnackbarComponent, {
      data,
      duration: duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'custom-snackbar'
    });
  }

  Info(message: string, duration: number = 2000) {

     const data: CustomSnackBarData = {
      icon: 'info',
      title: 'Info',
      message: message,
      color: '#5bc0de',
      duration: duration
    };

    this._snackBar.openFromComponent(CommonSnackbarComponent, {
      data,
      duration: duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'custom-snackbar'
    });
  }

  Warning(message: string, duration: number = 2000) {

     const data: CustomSnackBarData = {
      icon: 'warning',
      title: 'Action Required',
      message: message,
      color: '#f0ad4e',
      duration: duration
    };

    this._snackBar.openFromComponent(CommonSnackbarComponent, {
      data,
      duration: duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'custom-snackbar'
    });
  }
}
